module.exports = __webpack_public_path__ + "img/multilocation.460764c5.svg";